<template>
  <div class="productPage">
    <!-- banner -->
    <div class="banner">
      <img
        src="https://upload.vwingist.com/melscn/0image/2025/04/5671343098363373749.jpeg"
        alt=""
      />
      <!-- <img
        src="https://upload.vwingist.com/melscn/0image/2025/03/5476436031853208452.png"
        alt=""
      /> -->
    </div>

    <div class="group-layout group-layout-1 flex-rowl">
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/4658688685740126193.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div class="text-section">
        <h1 class="main-title">{{ $t("productPage.mainTitle") }}</h1>
        <p class="content" v-html="$t('productPage.mainContent')"></p>
      </div>
    </div>
    <div class="arr flex-rowc">
      <img
        src="https://upload.vwingist.com/melscn/0image/2025/03/4645935943454658991.png"
        alt=""
      />
    </div>
    <div class="group-layout group-layout-2 flex-rowl">
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5747561769018053736.png"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div class="text-section">
        <h1 class="sub-title-2">{{ $t("productPage.step1Title") }}</h1>
        <h1 class="sub-title-1">{{ $t("productPage.step1Subtitle") }}</h1>
        <p class="content" v-html="$t('productPage.step1Content')"></p>
        <div
          class="more-details-wrap"
          @mouseenter="showQRCode = true"
          @mouseleave="showQRCode = false"
        >
          <a
            href="javascript:;"
            class="more-details flex-rowl"
            v-html="$t('productPage.joinButton')"
          ></a>
          <div class="more-details-ercode" v-show="showQRCode">
            <img
              src="https://upload.vwingist.com/melscn/0image/2025/04/4633466339017024942.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="group-layout group-layout-3 flex-rowl">
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5691518042333162212.png"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div class="text-section">
        <h1 class="sub-title-2">{{ $t("productPage.step2Title") }}</h1>
        <h1 class="sub-title-1">{{ $t("productPage.step2Subtitle") }}</h1>
        <p class="content" v-html="$t('productPage.step3Content')"></p>
        <div
          class="more-details-wrap"
          @mouseenter="showQRCode1 = true"
          @mouseleave="showQRCode1 = false"
        >
          <a
            href="javascript:;"
            class="more-details flex-rowl"
            v-html="$t('productPage.joinButton')"
          ></a>
          <div class="more-details-ercode" v-show="showQRCode1">
            <img
              src="https://upload.vwingist.com/melscn/0image/2025/04/4633466339017024942.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="group-layout group-layout-4 flex-rowl">
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/4736904998851080325.png"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div class="text-section">
        <h1 class="sub-title-2">{{ $t("productPage.step3Title") }}</h1>
        <h1 class="sub-title-1">{{ $t("productPage.step3Subtitle") }}</h1>
        <p class="content" v-html="$t('productPage.step3Content')"></p>
        <div
          class="more-details-wrap"
          @mouseenter="showQRCode2 = true"
          @mouseleave="showQRCode2 = false"
        >
          <a
            href="javascript:;"
            class="more-details flex-rowl"
            v-html="$t('productPage.joinButton')"
          ></a>
          <div class="more-details-ercode" v-show="showQRCode2">
            <img
              src="https://upload.vwingist.com/melscn/0image/2025/04/4633466339017024942.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="new-group-layout flex-rowc">
      <!-- 左边内容 -->
      <div class="new-left-content">
        <h2 class="new-title" v-html="$t('productPage.newSectionTitle')"></h2>
        <p class="new-content" v-html="$t('productPage.newSectionContent')"></p>
        <div class="new-icons flex-rowl" @click="handleToast">
          <i class="icon-facebook"></i>
          <i class="icon-ins"></i>
          <i class="icon-cart"></i>
          <i class="icon-youtube"></i>
          <i class="icon-tiktok"></i>
        </div>
      </div>
      <!-- 右边内容 -->
      <div class="new-right-content flex-rowr">
        <!-- 右边内容的左右布局 -->
        <div class="new-right" @click="handleGo('/TechPage')">
          <div class="thumb image-container">
            <img
              src="https://upload.vwingist.com/melscn/0image/2025/02/5434954161480804639.png"
              alt=""
              class="zoomable-image"
            />
          </div>

          <h3 class="new-right-title">{{ $t("productPage.techPageTitle") }}</h3>
          <p class="new-right-text">{{ $t("productPage.techPageContent") }}</p>
        </div>
        <div class="new-right" @click="handleGo('/ProductCatalog')">
          <div class="thumb image-container">
            <img
              src="https://upload.vwingist.com/melscn/0image/2025/02/5372742187003798221.png"
              alt=""
              class="zoomable-image"
            />
          </div>

          <h3 class="new-right-title">{{ $t("productPage.productCatalogTitle") }}</h3>
          <p class="new-right-text">{{ $t("productPage.productCatalogContent") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "ProductPage",
  data() {
    return {
      // 添加响应式数据控制二维码显示隐藏
      showQRCode: false,
      showQRCode1: false,
      showQRCode2: false,
    };
  },
  mounted() {},
  methods: {
    handleGo(url) {
      this.$router.push(url);
    },

    handleToast() {
      this.$message.warning({
        message: "即将开放",
        center: true,
        duration: 1500,
        offset: 80,
      });
    },
  },
};
</script>
  <style lang="less">
.productPage {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .banner {
    // height: 600px;
    margin-bottom: 110px;
  }
  .main-title {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .sub-title-1 {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .sub-title-2 {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .main-subtitle {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .title {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .new-title {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .new-right-title {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .highlight {
    font-family: "SourceHanSerifCN-Medium", sans-serif;
  }
  .content {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .new-content {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .spec {
    font-size: 36px;
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .main-txt {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .new-right-text {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .more-details {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  p {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .more {
    font-family: "SourceHanSansCN-Light", sans-serif;
  }
  .group-layout {
    align-items: flex-start;
    &.group-layout-1 {
      padding: 0 340px 0 280px;
      box-sizing: border-box;
      .media-section {
        width: 500px;
        height: 330px;
        margin-right: 85px;
      }
    }
    &.group-layout-2 {
      padding-left: 344px;
      box-sizing: border-box;
      .media-section {
        width: 360px;
        height: 360px;
        margin-right: 68px;
      }
      .text-section {
        padding-top: 27px;
        width: 742px;
      }
    }
    &.group-layout-3 {
      box-sizing: border-box;
      margin: 93px 0 112px 274px;
      .media-section {
        width: 360px;
        height: 360px;
        margin-right: 68px;
      }
      .text-section {
        width: 742px;
        flex-shrink: 0;
        margin-top: 27px;
      }
    }
    &.group-layout-4 {
      padding-left: 434px;
      box-sizing: border-box;
      .media-section {
        width: 360px;
        height: 360px;
        margin-right: 68px;
      }
      .text-section {
        width: 738px;
      }
    }
    .media-section {
      flex-shrink: 0;
    }
    .text-section {
      color: #000000;
      .main-title {
        font-size: 50px;
        margin-bottom: 45px;
      }
      .sub-title-1 {
        font-size: 30px;
        margin: 15px 0 45px;
      }
      .sub-title-2 {
        font-size: 24px;
      }
      .content {
        font-size: 20px;
        line-height: 30px;
      }
      .more-details {
        width: 450px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        color: #000000;
        margin-top: 59px;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        &::after {
          display: inline-block;
          content: "";
          width: 7px;
          height: 15px;
          background: url(https://upload.vwingist.com/melscn/0image/2025/03/5724623272761848302.png)
            no-repeat center;
          background-size: cover;
          position: absolute;
          right: 20px;
        }
      }
    }
  }
  .arr {
    margin: 75px auto 63px;
    img {
      width: 35px;
      height: 30px;
    }
  }
  .new-group-layout {
    margin: 154px auto 176px;
    color: #000000;
    .new-left-content {
      width: 430px;
      flex-shrink: 0;
      margin-right: 35px;
      .new-title {
        font-size: 34px;
        span {
          font-size: 30px;
        }
      }
      .new-content {
        font-size: 24px;
        margin: 30px 0 55px;
        line-height: 36px;
      }
      .new-icons {
        i {
          display: inline-block;
          cursor: pointer;
          width: 29px;
          height: 29px;
          margin-right: 20px;
        }
        .icon-facebook {
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/5098712633813512321.png);
          background-size: cover;
        }
        .icon-ins {
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4853436759718255243.png);
          background-size: cover;
        }
        .icon-cart {
          width: 34px;
          height: 30px;
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4705043591895584161.png);
          background-size: cover;
        }
        .icon-youtube {
          width: 74px;
          height: 29px;
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4698212167918887025.png);
          background-size: cover;
        }
        .icon-tiktok {
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4973589452167469416.png);
          background-size: cover;
          margin-right: 0;
        }
      }
    }
    .new-right-content {
      align-items: flex-start;
      .new-right {
        width: 430px;
        flex-shrink: 0;
        &:last-child {
          margin-left: 30px;
        }
        .thumb {
          width: 430px;
          height: 660px;
        }
        .new-right-title {
          font-size: 36px;
          margin: 25px 0 35px;
        }
        .new-right-text {
          font-size: 24px;
        }
      }
    }
  }

  .more-details-wrap {
    position: relative;
    .more-details-ercode {
      width: 300px;
      height: 300px;
      background: #ffffff;
      border: 20px solid #e9e9e9;
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      left: 450px;
    }
  }
}
</style>